import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Form, Input, Row, Spin, Switch } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { get, Comment, CreateComment, UpdateComment } from '../../../../api';
import { useUser } from '../../../../hooks';

type CommentsFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateComment) => void;
  update: (v: UpdateComment) => void;
};

const CommentsForm: React.FC<CommentsFormProps> = ({ type, id, add, update }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { user } = useUser();

 const isSupplierOrCustomer =
  [3, 4].includes((user as any)?.role_id) ||
  ['Supplier', 'Customer'].includes((user as any)?.role_description);

  const { isLoading: isLoadingData, data } = useQuery<Comment>(
    [type],
    () => get<Comment>('/comments/' + id).then((e) => e.response),
    // { enabled: type !== 'add' && !!id }
  );

  useEffect(() => {
  if (type !== 'add' && id && data) {
    form.setFieldsValue({
      description: data.description,
      is_visible: isSupplierOrCustomer ? false : data.is_visible === 1,
    });
  }
}, [form, data, id, type, isSupplierOrCustomer]);

  const onSubmit = async (values: { description: string; is_visible: boolean }) => {
  setLoading(true);
  try {
    const payload: CreateComment = {
      description: values.description?.trim(),
      is_visible: isSupplierOrCustomer ? 0 : values.is_visible ? 1 : 0,
    };

    if (type === 'add') add(payload);
    else if (type === 'edit' && id != null) update({ id, ...payload });
  } finally {
    setLoading(false);
  }
};

  return (
    <Spin spinning={isLoadingData || loading} tip={<p>Cargando...</p>}>
      <Form
        name="comments"
        layout="vertical"
        form={form}
        onFinish={onSubmit}
        initialValues={{ is_visible: false }} 
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Comentario:"
                  name="description"
                  rules={[
                    { required: true, message: 'Por favor ingrese una descripción' },
                    { min: 2, message: 'Demasiado corta' },
                  ]}
                >
                  <Input.TextArea rows={5} placeholder="Escriba su comentario aquí" maxLength={500} />
                </Form.Item>
              </Col>

              {!isSupplierOrCustomer && (
                <Col span={24}>
                  <Form.Item
                    label="¿Visible en la página?"
                    name="is_visible"
                    valuePropName="checked"
                  >
                    <Switch
                      checkedChildren="Sí"
                      unCheckedChildren="No"
                      disabled={type === 'watch'}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === 'watch' || isLoadingData || loading}
                  loading={loading}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default CommentsForm;
